import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { Button, Text, Flex, Input } from "@mantine/core";

import { BasicForm } from "@components/shared";
import { initialState as contestInitialSettings } from "./ContestSettings/helpers";
import { currencyValidation } from "@util/validation";
import { dollarsToPennies } from "@util/formatters";
import timezones from "@lib/timezones";
import { todayStart, formatInputDate, dayStart, dayEnd } from "@util/dates";

import { contestWizardSettings } from "./helpers";

export default function ContestDateForm({ id, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({
    start_date: todayStart,
    start_time: dayStart,
    end_date: "",
    end_time: dayEnd,
  });
  const { t } = useTranslation();
  function onUpdate(formData) {
    const req = { ...formData };

    axios
      .put(`/contests/${id}/`, req)
      .then(() => {
        toast.success(t("common:updated") + "!");
        setLoading(false);
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <div>
      <Flex
        align="flex-end"
        gap="xs"
        direction={{
          base: "column",
          md: "row",
        }}
      >
        <Input.Wrapper label={t("common:start_date")} style={{ flexGrow: 1 }}>
          <Input
            // label="Start Date"
            type="date"
            value={formState.start_date}
            onChange={(e) =>
              setFormState({
                ...formState,
                start_date: e.target.value,
              })
            }
          />
        </Input.Wrapper>
        <Input.Wrapper label={t("common:start_time")} style={{ flexGrow: 1 }}>
          <Input
            type="time"
            value={formState.start_time}
            onChange={(e) =>
              setFormState({
                ...formState,
                start_time: e.target.value,
              })
            }
          />
        </Input.Wrapper>
        <Input.Wrapper label={t("common:end_date")} style={{ flexGrow: 1 }}>
          <Input
            type="date"
            value={formState.end_date}
            onChange={(e) =>
              setFormState({
                ...formState,
                end_date: e.target.value,
              })
            }
          />
        </Input.Wrapper>
        <Input.Wrapper label={t("common:end_time")} style={{ flexGrow: 1 }}>
          <Input
            type="time"
            value={formState.end_time}
            onChange={(e) =>
              setFormState({
                ...formState,
                end_time: e.target.value,
              })
            }
          />
        </Input.Wrapper>
        <Button
          onClick={() => onUpdate(formState)}
          loading={loading}
          disabled={
            !formState.start_date ||
            !formState.end_date ||
            !formState.start_time ||
            !formState.end_time
          }
        >
          {t("common:save")}
        </Button>
      </Flex>
    </div>
  );
}
